// extracted by mini-css-extract-plugin
module.exports = {"loader":"Ab","smallLoader":"Bb","loading-keyframes":"Cb","pageLoader":"Db","centered":"Eb","whitespacePlaceholder":"Fb","buttonSpinner":"Gb","fade-in":"Hb","rotate":"Ib"};